/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetLoyaltyProfileQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetLoyaltyProfileQuery = {
  readonly __typename?: 'Query';
  readonly loyaltyProfile: {
    readonly __typename?: 'LoyaltyProfile';
    readonly customerId: string;
    readonly tier: {
      readonly __typename?: 'Tier';
      readonly id: string;
      readonly name: Types.TierName;
      readonly tierGroup: {
        readonly __typename?: 'TierGroup';
        readonly id: string;
        readonly name: string;
      };
      readonly nextTier: {
        readonly __typename?: 'Tier';
        readonly id: string;
        readonly name: Types.TierName;
      } | null;
    } | null;
  } | null;
};

export const getLoyaltyProfileQueryMock: ExecutionResult<GetLoyaltyProfileQuery> =
  {
    data: {
      loyaltyProfile: {
        customerId: 'e509e6ea-9fee-442a-9962-587ce7190430',
        tier: {
          id: '8da7a716-3ba7-4eda-96e8-a185e3da00a9',
          name: 'OPTED_OUT',
          tierGroup: {
            id: 'a4753431-9d08-4060-b59a-a250f9c4016b',
            name: '1bd634cb-273b-47f9-b18d-030f1b1f2c49',
          },
          nextTier: {
            id: 'f5fd7994-ccdc-4ab3-8b74-85afbe88532e',
            name: 'OPTED_OUT',
          },
        },
      },
    },
  };

export const GetLoyaltyProfileDocument = gql`
  query GetLoyaltyProfile {
    loyaltyProfile {
      customerId
      tier {
        id
        name
        tierGroup {
          id
          name
        }
        nextTier {
          id
          name
        }
      }
    }
  }
`;

export function useGetLoyaltyProfileQuery(
  options?: Omit<Urql.UseQueryArgs<GetLoyaltyProfileQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetLoyaltyProfileQuery, GetLoyaltyProfileQueryVariables>(
    { query: GetLoyaltyProfileDocument, ...options },
  );
}
